<template>
  <IntercomTopbar
    :app-name="appName"
    :product-name="productName"
    :business-name="businessName"
    :user="user"
    :global-user="globalUser"
    :search-placeholder="searchPlaceholder"
    :search-fn="wrappedSearchFn"
    :show-notifications="false"
    :show-settings="false"
    @select-customer="handleSelectMember"
    @logout="$emit('logout')"
  />
</template>

<script setup>
import { IntercomTopbar } from '@shared/components/intercom'

const props = defineProps({
  appName: {
    type: String,
    default: 'OnePlaceHQ',
  },
  productName: {
    type: String,
    default: 'Gym',
  },
  businessName: {
    type: String,
    default: '',
  },
  user: {
    type: Object,
    default: null,
  },
  globalUser: {
    type: Object,
    default: null,
  },
  searchPlaceholder: {
    type: String,
    default: 'Search members...',
  },
  searchFn: {
    type: Function,
    default: null,
  },
})

const emit = defineEmits(['logout', 'select-member'])

/**
 * Wrap the search function to transform gym results to IntercomTopbar expected format
 * IntercomTopbar expects: { customers: [...], pledges: [...] }
 * Gym search returns: { members: [...], plans: [...] }
 */
const wrappedSearchFn = props.searchFn
  ? async (query) => {
      const result = await props.searchFn(query)
      return {
        // Map members to customers format for IntercomTopbar
        customers: (result.members || []).map((member) => ({
          id: member.id,
          name: member.name,
          phone: member.phone,
          // Include additional fields for display
          member_number: member.member_number,
          plan_name: member.plan_name,
          status: member.status,
        })),
        // Plans could be shown in pledges section, but for now we skip
        pledges: [],
      }
    }
  : null

const handleSelectMember = (member) => {
  emit('select-member', member)
}
</script>
